import { render } from "./Brush.vue?vue&type=template&id=2df3c5fd&scoped=true"
import script from "./Brush.vue?vue&type=script&lang=js"
export * from "./Brush.vue?vue&type=script&lang=js"

import "./Brush.vue?vue&type=style&index=0&id=2df3c5fd&scoped=true&lang=css"

import exportComponent from "/home/runner/work/vertex/vertex/webui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2df3c5fd"]])

export default __exports__